import styled from 'styled-components'
export const Wrapper = styled.div`
  .description {
    overflow: auto;
    word-wrap: break-word;
    white-space: break-spaces;
    /* max-height: 80px; */
    position: relative;
    min-height: 47px;
    display: block;
    max-width: 800px;
  }
`
